import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, ArrowLeft } from 'lucide-react';

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-pink-900 to-yellow-900 flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", duration: 0.8 }}
        className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl max-w-2xl w-full overflow-hidden"
      >
        {/* Header with gradient */}
        <div className="bg-gradient-to-r from-purple-600 via-pink-600 to-yellow-500 p-12 relative">
          <motion.div
            animate={{
              rotate: [0, 10, -10, 10, -10, 0],
              scale: [1, 1.2, 1.2, 1.2, 1.2, 1]
            }}
            transition={{
              duration: 0.8,
              ease: "easeInOut",
              repeat: Infinity,
              repeatDelay: 2
            }}
            className="flex justify-center mb-6"
          >
            <Sparkles size={96} className="text-white" />
          </motion.div>
          
          <h1 className="text-5xl font-bold text-white text-center mb-4">
            Coming Soon!
          </h1>
          <p className="text-xl text-white/90 text-center">
            Unschooling Mode
          </p>
        </div>

        {/* Content */}
        <div className="p-12 text-center">
          <p className="text-2xl text-gray-700 dark:text-gray-300 mb-6 font-semibold">
            We're building something amazing! ✨
          </p>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            Unschooling Mode is currently under development. We're working hard to bring you an incredible learning experience that will transform the way you explore and discover knowledge.
          </p>
          
          <div className="space-y-4">
            <motion.button
              onClick={() => navigate('/dashboard')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-yellow-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
            >
              <ArrowLeft size={20} />
              Back to Dashboard
            </motion.button>
            
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Stay tuned for updates! 🚀
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ComingSoon;
